import { useEffect, useMemo, useState } from 'react';

//MRT Imports
//import MaterialReactTable, { type MRT_ColumnDef } from 'material-react-table'; //default import deprecated
import { MaterialReactTable } from 'material-react-table';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

//Mock Data

import { message } from "antd";

import Cookies from 'js-cookie';

import axios from 'axios';

import useFetchCommon from '../../../hooks/getCommonData';
import { BASE_URL, BASE_URL_TWO } from '../../../../utils';
import { KTIcon } from '../../../../_metronic/helpers';
import PopUp from '../../../components/Modal/Modal';
import { Grid, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import VisaAdd from './VisaAdd';
import VisaEdit from './VisaEdit';


export const Employee = {
    companyName: '',
    address: '',
};


const VisaList = () => {

    const id = Cookies.get('userId');
    const token = Cookies.get("token")

    const [shouldRefetch, setShouldRefetch] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState()
    const [show, setShow] = useState(false);
    const [actionStatus, setActionStatus] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [open, setOpen] = useState(false)
    const [visible, setVisible] = useState(false);
    const [editVisible, setEditVisible] = useState(false);

    const headers = {
        'token': token,
        'Content-Type': 'application/json'
    };

    const { commonDataFetch } = useFetchCommon(`getVisaTypes`, {}, [shouldRefetch]);

    const tableData = commonDataFetch || [];


    const showMessage = (msg) => {
        message.success({
            content: msg,
            duration: 4 // Duration in seconds
        });
    };

    const handleDelete = async () => {
        try {
            await axios.post(`${BASE_URL_TWO}`, {
                sp: 'delVisaType',
                visaTypeId: deleteId,
            });
            message.destroy();
            setActionStatus(false);
            message.success('Visa Type deleted successfully.');
            setShouldRefetch(!shouldRefetch);
        } catch (error) {
            setActionStatus(false);
            message.destroy();
            message.error("Unable to delete this visa type");
        }
    }

    useEffect(() => {
        if (actionStatus && deleteId) {
            handleDelete()
        }
    }, [actionStatus, deleteId])


    return (
        <>
            <VisaEdit visible={editVisible} setSelectedCompany={setSelectedCompany} shouldRefetch={shouldRefetch} onClose={() => setEditVisible(false)} selectedCompany={selectedCompany} setShouldRefetch={setShouldRefetch} />
            <PopUp
                title="Delete Visa Type"
                message="Are you sure you want to Delete this Visa type?"
                btnName="Delete"
                setActionStatus={setActionStatus}
                show={show}
                setShow={setShow}
            />
            <div className='d-flex justify-content-between align-items-center'>
                <VisaAdd visible={visible} onClose={() => setVisible(false)} shouldRefetch={shouldRefetch} setShouldRefetch={setShouldRefetch} />
                <h5 className="text-black-50 mb-10">
                    <i className="bi bi-caret-right-fill fs-2 me-2 svg-icon-muted text-black-50"></i> {/* icon */} Visa Types
                </h5>

                <div className="card-toolbar me-5">
                    {/* Button to open the modal */}
                    <span
                        className="btn btn-md btn-light-primary border"
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                        title="New Entry"
                        onClick={()=>setVisible(true)}
                    >
                        <KTIcon iconName="plus" className="fs-2" />
                        New Entry
                    </span>
                </div>
            </div>

            <Grid container sx={{ justifyContent: 'center' }}>
                <Grid container>
                    <table className="table table-rounded border border-gray-300 table-row-bordered table-row-gray-300 bg-white gy-5 gs-7 shadow">
                        <thead>
                            <tr className="fw-bold fs-5 bg-primary rounded text-white">
                                <th>#</th>
                                <th>Visa Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                commonDataFetch?.map((data, index) =>
                                    <tr style={{ borderBottom: "" }} key={index}>
                                        <td className="text-primary fw-bold"><span className="badge">{index + 1}</span></td>
                                        <td className="text-primary fw-bold">{data?.visaType}</td>
                                        <td>
                                            <Tooltip title="Delete" arrow>
                                                <DeleteIcon
                                                    onClick={() => { setDeleteId(data?.visaTypeId); setShow(true) }}
                                                    style={{ cursor: "pointer", color: 'rgb(18 54 125)' }}
                                                    title="Delete"
                                                />
                                            </Tooltip>
                                            <span
                                                onClick={() => { setSelectedCompany(data); setEditVisible(true) }} // Pass selected position
                                                data-kt-menu-trigger='click'
                                                data-kt-menu-placement='bottom-end'
                                                data-kt-menu-flip='top-end'
                                                title="Edit"
                                            >
                                                <Tooltip title="Edit" arrow>
                                                    <ModeEditIcon
                                                        sx={{
                                                            cursor: 'pointer',
                                                            ml: 2,

                                                        }}
                                                        className='text-primary'
                                                    />
                                                </Tooltip>
                                            </span>
                                        </td>
                                    </tr>
                                )
                            }
                            { }
                            {commonDataFetch?.length <= 0 && <tr><td className='text-center' colSpan={3}>No Records Found</td></tr>}
                        </tbody>
                    </table>
                </Grid>
            </Grid>
        </>
    );
};

export default VisaList;